module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-358.fb9a44f.woff2";